import { NavLink } from "react-router-dom";
import classes from "./NavItem.module.css";
import classNames from "classnames";

const NavItem = (props) => {
  const { destination, content, uniqueId, visibleOnMobileOnly } = props;

  return (
    <li
      className={classNames("text-dark-blue", "font-bold", "text-2xl", {
        [classes["mobile-nav-item"]]: visibleOnMobileOnly,
      })}
    >
      <NavLink id={uniqueId} to={destination}>
        {content}
      </NavLink>
    </li>
  );
};

export default NavItem;
